import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faEllipsisH,
  faEdit,
  faTrashAlt,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Nav,
  Row,
  Form,
  Pagination,
  Card,
  Table,
  Button,
  ButtonGroup,
  InputGroup,
  Dropdown,
  Badge,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { Routes } from "../../routes";
import axios from "axios";
import Loader from "../../components/Loader";
import {
  getContracts,
  deleteContract,
  getFetchContractsTemplate,
} from "../../app/api";
import swal from "sweetalert";
import moment from "moment";
export default () => {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0); // State to hold total pages
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const accesstoken = localStorage.getItem("adobe_access_token");
  const [showFullTextMap, setShowFullTextMap] = useState({});
  const maxLength = 20;
  const handleAdobeFetchContract = async () => {
    // Retrieve environment variables
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(getFetchContractsTemplate(), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
          accessToken: accesstoken,
        },
      });
      // console.log(response?.data?.data);
    } catch (error) {
      // console.error("Error fetching vendors:", error.response.data.error);
    }
  };
  const fetchContracts = async (currentPage) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getContracts(), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
        params: {
          page: currentPage, // Send the current page as a query parameter
          search,
        },
      });
      console.log(response.data.data);

      setContracts(response.data?.data);
      setTotalPages(response.data?.pagination?.total_pages);
      handleAdobeFetchContract()
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };  const toggleShowFullText = (contractId) => {
    setShowFullTextMap(prevState => ({
      ...prevState,
      [contractId]: !prevState[contractId],
    }));
  };
  useEffect(() => {
    fetchContracts(page);
  }, [page, search]);
  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(deleteContract(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      swal({
        text: response.data.message,
        icon: "success",
      });
    } catch (error) {
      swal({
        text: error.response.data.messages.error,
        icon: "error",
      });
      // console.error("Error fetching vendors:", error);
    }
    fetchContracts(page);
  };
  
  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
        <div className="d-block  mb-md-0">
          <h4 className="mb-0">Contracts Management</h4>
          {/* <p className="mb-0">Your web analytics dashboard template.</p> */}
        </div>
        <Col xs={12} md={4} lg={4} xl={4} className=" mb-sm-2">
          <InputGroup>
            <InputGroup.Text>
              <FontAwesomeIcon icon={faSearch} />
            </InputGroup.Text>
            <Form.Control
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              placeholder="Search"
            />
          </InputGroup>
        </Col>
        {/* <Button onClick={handleAdobeFetchContract}>Fetch Signed</Button> */}
        <Button
          variant="primary"
          className=" me-2"
          as={Link}
          to={Routes.ContractsAdd.path}
        >
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          <span>New</span>
        </Button>
      </div>
      {/* 
      <div className="table-settings mb-4">
        <Row className="justify-content-between align-items-center">
         
        </Row>
      </div> */}
      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body className="p-0">
          <Table hover className="user-table align-items-center">
            {loading ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Loader />
              </div>
            ) : (
              <>
                <thead>
                  <tr>
                    <th className="border-bottom">Title</th>
                    <th className="border-bottom">Vendor Name</th>
                    <th className="border-bottom">Template</th>
                    <th className="border-bottom">Sent Detail</th>
                    <th className="border-bottom">Sign Date</th>
                    <th className="border-bottom">Expiry Date</th>
                    <th className="border-bottom">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {contracts.map((contract, index) => {
                    // Convert the expiration date to a Date object
                    const expiryDate = new Date(contract.expiration_date);
                    const currentDate = new Date();

                    // Calculate the difference in milliseconds
                    const timeDifference = expiryDate - currentDate;

                    // Convert the difference to days
                    const daysDifference = Math.ceil(
                      timeDifference / (1000 * 60 * 60 * 24)
                    );

                    // Determine the badge color
                    const badgeColor =
                      daysDifference <= 15 ? "danger" : "primary";

                    return (
                      <tr key={index}>
                        <td className="fw-normal">
                          {" "}
                          <Link
                            className="Link_underline"
                            to={`${Routes.ContractsDetail.path}/${contract.id}`}
                          >
                            {contract.title}
                          </Link>
                        </td>
                        <td>
                          <span className="fw-normal">{contract?.vendor_name}</span>
                        </td>
                        <td>
                      {contract?.template_name?.length > maxLength ? (
                        <span
                          className="fw-normal"
                          style={{ cursor: 'pointer' }}
                          onClick={() => toggleShowFullText(contract.id)}
                          title={!showFullTextMap[contract.id] ? contract.template_name : undefined}
                        >
                          {showFullTextMap[contract.id]
                            ? contract.template_name
                            : `${contract.template_name.substring(0, maxLength)}...`}
                        </span>
                      ) : (
                        <span className="fw-normal">{contract?.template_name}</span>
                      )}
                    </td>
                        <td>
                          <span className="fw-normal">{contract?.status}</span>
                        </td>
                        <td>
                          <span className="fw-normal">
                            {contract?.vendorsigndate === "0000-00-00 00:00:00" || contract?.adobe_agreement_id === null || contract?.vendorsigndate === null
                              ? "Not Signed"
                              : `${contract?.vendorsigndate}`}
                          </span>
                        </td>
                        <td>
                          <span className="fw-normal">
                            {" "}
                            <Badge
                              pill
                              bg={badgeColor}
                              style={{
                                padding: "0.4rem 1rem",
                                fontSize: "0.85rem",
                                border: "1px solid #ddd",
                              }}
                            >
                              {moment(contract?.expiration_date).format(
                                "MM/DD/YYYY HH:mm"
                              )}
                            </Badge>
                          </span>
                        </td>
                        <td>
                          <Dropdown as={ButtonGroup}>
                            <Dropdown.Toggle
                              as={Button}
                              split
                              variant="link"
                              className="text-dark m-0 p-0"
                            >
                              <span className="icon icon-sm">
                                <FontAwesomeIcon
                                  icon={faEllipsisH}
                                  className="icon-dark"
                                />
                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item>
                                <Link
                                  className="me-2"
                                  to={`${Routes.ContractsDetail.path}/${contract.id}`}
                                >
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={faEye}
                                    className="me-2"
                                  />{" "}
                                  View Details
                                </Link>
                              </Dropdown.Item>
                              <Dropdown.Item>
                                <Link
                                  as={Link}
                                  to={`${Routes.ContractsAdd.path}/${contract.id}`}
                                >
                                  <FontAwesomeIcon
                                    icon={faEdit}
                                    className="me-2"
                                  />{" "}
                                  Edit
                                </Link>
                              </Dropdown.Item>
                              <Dropdown.Item className="text-danger">
                                <div onClick={() => handleDelete(contract.id)}>
                                  <FontAwesomeIcon
                                    icon={faTrashAlt}
                                    className="me-2"
                                  />{" "}
                                  Remove
                                </div>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </>
            )}
          </Table>
          <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-center">
            <Nav className="justify-content-center mb-4">
              <Pagination className="mb-2 mb-lg-0">
                <Pagination.Prev
                  onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                />
                {Array.from({ length: totalPages }, (_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === page}
                    onClick={() => setPage(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  onClick={() =>
                    setPage((prev) => Math.min(prev + 1, totalPages))
                  }
                />
              </Pagination>
            </Nav>
          </Card.Footer>
        </Card.Body>
      </Card>
    </>
  );
};
